export default "__VITE_PUBLIC_ASSET__23c87b08__"